
import { apiSlice } from "../apiSlice";

export const categoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    categoryList: builder.mutation({
      query: (data) => ({
        url: "/category/list?" + data,
        method: "POST",
        credentials: "include",
      }),

    }),
    categoriesList: builder.query({
      query: (queryParams) => ({
        url: "/category/list",
        method: "POST",
        credentials: "include"
      })

    }),
    getCategoriesList: builder.query({
      query: () => ({
        url: `/category/list?page=1&limit=100`,
        method: "POST",
        credentials: "include",
      }),

    }),
    categoryTree: builder.mutation({
      query: (data) => ({
        url: "/category/tree",
        method: "GET",

        credentials: "include",
      }),

    }),
    allCategoryTreeList: builder.query({
      query: (data) => ({
        url: "/category/tree",
        method: "GET",

        credentials: "include",
      }),

    }),
    createCategory: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: "/category",
        method: "POST",
        body: { id, ...patch },

        credentials: "include",
      }),
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedPost } = await queryFulfilled
          // if (id) {
          //   const patchResult = dispatch(
          //     categoryApi.util.updateQueryData('categoryList', id, (draft) => {
          //       Object.assign(draft, updatedPost)
          //     })
          //   )
          // }

        } catch { }
      },

    }),
    getCategory: builder.mutation({
      query: (id) => ({
        url: `/category/${id}`,
        method: "GET",

        credentials: "include",
      }),



    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/category`,

        method: "DELETE",
        body: { id: id },

        credentials: "include",
      }),



    }),


  }),
});

export const {
  useCreateCategoryMutation,
  useCategoryListMutation,
  useGetCategoryMutation,
  useDeleteCategoryMutation,
  useCategoryTreeMutation,
  useGetCategoriesListQuery,
  useAllCategoryTreeListQuery,
  useCategoriesListQuery
} = categoryApi;
